function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Button, Space, Table, message, Drawer, Select, Form, DatePicker, Collapse } from 'antd';
import Common from '../components/includes/Common';
import { Truck } from 'react-bootstrap-icons';
import AddOrder from '../components/forms/AddOrder';
import OrderListView from '../components/OrderListView';
import moment from "moment";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Order = function Order() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    providersList = _useState2[0],
    setProvidersList = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataChanged = _useState4[0],
    setIsDataChanged = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setIsDataLoading = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedProvider = _useState8[0],
    setSelectedProvider = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isNewOrderOpen = _useState10[0],
    setIsNewOrderOpen = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    stationsOptions = _useState12[0],
    setStationsOptions = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedStation = _useState14[0],
    setSelectedStation = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    stationsList = _useState16[0],
    setStationsList = _useState16[1];
  var _useState17 = useState(moment().startOf('month').format()),
    _useState18 = _slicedToArray(_useState17, 2),
    orderFrom = _useState18[0],
    setOrderFrom = _useState18[1];
  var _useState19 = useState(moment().endOf('month').format()),
    _useState20 = _slicedToArray(_useState19, 2),
    orderTo = _useState20[0],
    setOrderTo = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    orderList = _useState22[0],
    setOrderList = _useState22[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 2),
    form = _Form$useForm2[0],
    orderform = _Form$useForm2[1];
  var handleNewOrder = function handleNewOrder(provider) {
    setSelectedProvider(provider);
    if (selectedStation != null) setIsNewOrderOpen(true);
  };
  var onOrderSearchFinish = function onOrderSearchFinish(value) {};
  var cols = [{
    title: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(Truck, {
        size: 25
      }), " Fournisseur"]
    }),
    dataIndex: 'label',
    key: 'label',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: 'Balance',
    dataIndex: 'balance',
    key: 'balance',
    render: function render(text) {
      return /*#__PURE__*/_jsxs("b", {
        children: [text.toLocaleString('Fr'), " GNF"]
      });
    }
  }, {
    title: 'E-mail',
    responsive: ['lg', 'md'],
    dataIndex: 'mail',
    key: 'label',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: 'Station',
    dataIndex: 'gas_station',
    key: 'gas_station',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: 'Action',
    dataIndex: 'provider',
    key: 'provider',
    render: function render(provider) {
      return /*#__PURE__*/_jsx(Space, {
        direction: "horizontal",
        children: /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            handleNewOrder(provider);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "FAIRE UNE COMMANNDE"
          })
        })
      });
    }
  }];
  var getAllData = function getAllData() {
    if (Common.currentStation == 'undefined') return;
    axios.all([axios.get(Common.baseApiUrl + 'getproviders/' + Common.currentStation.id + '/' + Common.currentUser.id.toString()), axios.get(Common.baseApiUrl + 'getproducts/' + Common.currentStation.id + '/' + Common.currentUser.id.toString()), axios.get(Common.baseApiUrl + 'getgasstationorders/' + Common.currentStation.id + '/' + Common.currentUser.id + "/" + orderFrom + "/" + orderTo)]).then(function (response) {
      setIsDataLoading(true);
      if (response[0].data.status == 200) {
        setProvidersList([]);
        response[0].data.providers.forEach(function (p) {
          setProvidersList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: p.id,
              label: p.label,
              balance: p.balance,
              mail: p.mail,
              gas_station: p.gas_station.label,
              provider: p
            }]);
          });
        });
      } else {
        message.error({
          content: response[0].data.message,
          delay: 4
        });
      }
      setOrderList([]);
      if (response[2].data.status == 200) {
        setOrderList(response[2].data.orders);
      } else {
        message.error({
          content: "Une erreur est survenue",
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  useEffect(function () {
    getAllData();
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Table, {
            columns: cols,
            bordered: true,
            loading: isDataLoading,
            size: "small",
            pagination: false,
            dataSource: providersList
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Collapse, {
            ghost: true,
            items: [{
              key: 1,
              label: /*#__PURE__*/_jsx("b", {
                children: "Filtrer par p\xE9riode"
              }),
              children: /*#__PURE__*/_jsx(_Fragment, {
                children: /*#__PURE__*/_jsx(Form, {
                  form: orderform,
                  layout: "horizontal",
                  onFinish: onOrderSearchFinish,
                  children: /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 5,
                      sm: 8,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "period",
                        rules: [{
                          required: true,
                          message: 'Champ obligatoire'
                        }],
                        children: /*#__PURE__*/_jsx(RangePicker, {})
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 1,
                      md: 3,
                      sm: 4,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        children: /*#__PURE__*/_jsx(Button, {
                          type: "primary",
                          htmlType: "submit",
                          children: /*#__PURE__*/_jsx("b", {
                            children: "RECHERCHE"
                          })
                        })
                      })
                    })]
                  })
                })
              })
            }]
          }), /*#__PURE__*/_jsx(OrderListView, {
            orderList: orderList,
            loading: setIsDataLoading,
            dataRefreshHandler: function dataRefreshHandler() {
              setIsDataChanged(true);
            }
          })]
        })
      })
    }), selectedProvider != null && selectedStation != null && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs("b", {
        children: ["NVLLE COMMANDE - ", selectedProvider.label]
      }),
      width: "380px",
      destroyOnClose: true,
      open: isNewOrderOpen,
      onClose: function onClose() {
        setIsNewOrderOpen(false);
      },
      children: /*#__PURE__*/_jsx(AddOrder, {
        provider: selectedProvider,
        handler: function handler() {
          setIsNewOrderOpen(false);
          setIsDataChanged(true);
          message.success({
            content: 'La commande est créée et en attente de validation',
            delay: 8
          });
        },
        station: selectedStation
      })
    })]
  });
};
export default Order;